import React, { useState, useEffect } from "react";
import API_BASE_URL from '../config';

export default function Footer() {
  const linkStyle = { display: 'block', marginBottom: 18, textDecoration: 'underline', color: '#111', fontWeight: 600 };
  const smallLink = { display: 'block', marginBottom: 10, textDecoration: 'underline', color: '#111' };

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/settings`)
      .then(res => res.json())
      .then(data => {
        if (data && data.footer_settings) {
          try {
            const parsed = typeof data.footer_settings === 'string'
              ? JSON.parse(data.footer_settings)
              : data.footer_settings;
            if (parsed && typeof parsed === 'object') {
              setSettings(parsed);
            }
          } catch (e) {
            // ignore
          }
        }
      })
      .catch(e => console.error('Failed to load footer settings', e));
  }, []);

  const defaultCol1 = [
    { id: '1', text: 'Rreth kompanisë', href: '#about', isHeader: true },
    { id: '2', text: 'Ne suportojmë', href: 'https://globe.al/sherbimet', isHeader: false },
    { id: '3', text: 'Karriera', href: 'https://globe.al/karriera', isHeader: false },
    { id: '4', text: 'Financim', href: 'https://globe.al/financim', isHeader: false },
    { id: '5', text: 'Formular kontakti', href: 'https://globe.al/karriera', isHeader: false },
  ];
  const defaultCol2 = [
    { id: '6', text: 'Politika e privatësisë', href: '#privacy', isHeader: true },
    { id: '7', text: 'Politikat e privatësisë së rekrutimit', href: '#recruitment', isHeader: false },
    { id: '8', text: 'Kushtet e përdorimit', href: '#terms', isHeader: false },
    { id: '9', text: 'Cookies', href: '#cookies', isHeader: false },
  ];
  const defaultCol3 = [
    { id: '10', text: 'Shërbimet tona', href: '#services', isHeader: true },
    { id: '11', text: 'Transporti & Dërgesa', href: 'https://globe.al/sherbimet', isHeader: false },
    { id: '12', text: 'Garancia & Servisi', href: 'https://globe.al/sherbimet', isHeader: false },
    { id: '13', text: 'Dyqanet tona', href: '/locations', isHeader: false },
  ];
  const defaultCol4 = [
    { id: '14', text: 'Informacione', href: '#info', isHeader: true },
    { id: '15', text: 'Pyetje të Shpeshta', href: '#faq', isHeader: false },
    { id: '16', text: 'Katalogu Online', href: '#catalog', isHeader: false },
    { id: '17', text: 'Ndihmë & Suport', href: '#support', isHeader: false },
  ];
  const defaultContact = {
    title: 'KONTAKTO',
    phoneText: '+355 44 806 061',
    phoneHref: 'tel:+35544806061',
    emailText: 'info@globe.al',
    emailHref: 'mailto:info@globe.al',
    address: 'Rruga e Kavajes, Tirane 1023, Albania'
  };
  const defaultSocial = {
    facebook: 'https://www.facebook.com/GlobeAlbania/?locale=sq_AL',
    instagram: 'https://www.instagram.com/globe.al/',
    whatsapp: 'https://wa.me/35544806061',
    linkedin: 'https://www.linkedin.com/company/globe-albania?originalSubdomain=al',
  };

  const col1 = settings?.col1?.length ? settings.col1 : defaultCol1;
  const col2 = settings?.col2?.length ? settings.col2 : defaultCol2;
  const col3 = settings?.col3?.length ? settings.col3 : defaultCol3;
  const col4 = settings?.col4?.length ? settings.col4 : defaultCol4;
  const contactInfo = settings?.contactInfo || defaultContact;
  const socialLinks = settings?.socialLinks || defaultSocial;

  // Determine column order - defaults to 4 columns: col1, col2, col3, and contact
  let columnOrder = (Array.isArray(settings?.columnOrder) && settings.columnOrder.length > 0)
    ? [...settings.columnOrder]
    : ['col1', 'col2', 'col3', 'contact'];

  // Seamless backwards compatibility: if col3 is not present in saved order, insert it before contact
  if (!columnOrder.includes('col3')) {
    const cIdx = columnOrder.indexOf('contact');
    if (cIdx !== -1) {
      columnOrder.splice(cIdx, 0, 'col3');
    } else {
      columnOrder.push('col3');
    }
  }

  const renderColumn = (colKey) => {
    if (colKey === 'col1') {
      return (
        <div key="col1" className="footer-col" style={{ flex: '1 1 200px', minWidth: 180 }}>
          {col1.map(link => (
            <a key={link.id} href={link.href} style={link.isHeader ? linkStyle : smallLink}>{link.text}</a>
          ))}
        </div>
      );
    }
    if (colKey === 'col2') {
      return (
        <div key="col2" className="footer-col" style={{ flex: '1 1 200px', minWidth: 180 }}>
          {col2.map(link => (
            <a key={link.id} href={link.href} style={link.isHeader ? linkStyle : smallLink}>{link.text}</a>
          ))}
        </div>
      );
    }
    if (colKey === 'col3') {
      return (
        <div key="col3" className="footer-col" style={{ flex: '1 1 200px', minWidth: 180 }}>
          {col3.map(link => (
            <a key={link.id} href={link.href} style={link.isHeader ? linkStyle : smallLink}>{link.text}</a>
          ))}
        </div>
      );
    }
    if (colKey === 'col4') {
      return (
        <div key="col4" className="footer-col" style={{ flex: '1 1 200px', minWidth: 180 }}>
          {col4.map(link => (
            <a key={link.id} href={link.href} style={link.isHeader ? linkStyle : smallLink}>{link.text}</a>
          ))}
        </div>
      );
    }
    if (colKey === 'contact') {
      return (
        <div key="contact" className="footer-col footer-col-contact" style={{ flex: '1 1 260px', minWidth: 220 }}>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>{contactInfo.title}</div>
          <div style={{ marginBottom: 8 }}><span style={{ fontWeight: 700 }}>N:</span> <a href={contactInfo.phoneHref} style={{ textDecoration: 'underline', color: '#111' }}>{contactInfo.phoneText}</a></div>
          <div style={{ marginBottom: 8 }}><span style={{ fontWeight: 700 }}>E:</span> <a href={contactInfo.emailHref} style={{ textDecoration: 'underline', color: '#111' }}>{contactInfo.emailText}</a></div>
          <div style={{ marginBottom: 16 }}><span style={{ fontWeight: 700 }}>A:</span> {contactInfo.address}</div>

          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            {/** Social icon button - Facebook */}
            <a
              href={socialLinks.facebook || '#'}
              aria-label="Facebook"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>

            {/** Instagram */}
            <a
              href={socialLinks.instagram || '#'}
              aria-label="Instagram"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              title="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>

            {/** WhatsApp */}
            <a
              href={socialLinks.whatsapp || '#'}
              aria-label="WhatsApp"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              title="WhatsApp"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.301-.15-1.78-.878-2.056-.978-.276-.1-.477-.15-.678.15-.2.301-.778.978-.954 1.179-.175.2-.351.226-.652.075-.301-.151-1.272-.469-2.423-1.496-.895-.799-1.5-1.786-1.676-2.087-.175-.301-.019-.464.132-.614.135-.135.301-.351.451-.527.151-.175.201-.301.301-.502.1-.2.05-.376-.025-.526-.075-.151-.678-1.632-.929-2.234-.244-.587-.492-.507-.678-.516-.175-.008-.376-.01-.577-.01-.201 0-.527.075-.803.376-.276.301-1.054 1.029-1.054 2.509 0 1.48 1.079 2.91 1.229 3.11.151.201 2.124 3.243 5.145 4.548 3.021 1.305 3.021.87 3.573.82.552-.05 1.78-.728 2.031-1.431.251-.703.251-1.305.176-1.431-.075-.126-.276-.201-.577-.351z"/>
                <path d="M12.004 0C5.373 0 .004 5.373.004 12c0 2.114.552 4.168 1.603 5.986L.004 24l6.19-1.624C7.946 23.377 9.947 24 12.004 24c6.627 0 12-5.373 12-12s-5.373-12-12-12zm0 21.933c-1.802 0-3.568-.485-5.109-1.401l-.366-.217-3.79 1 .993-3.694-.239-.38A9.878 9.878 0 0 1 2.07 12c0-5.478 4.456-9.933 9.934-9.933 5.478 0 9.934 4.455 9.934 9.933 0 5.478-4.456 9.933-9.934 9.933z"/>
              </svg>
            </a>

            {/** LinkedIn */}
            <a
              href={socialLinks.linkedin || '#'}
              aria-label="LinkedIn"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              title="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.46 10.9v8.37H9.2V10.9H6.46M7.83 6.45a1.64 1.64 0 0 0-1.64 1.64 1.64 1.64 0 0 0 1.64 1.64 1.64 1.64 0 0 0 1.64-1.64 1.64 1.64 0 0 0-1.64-1.64z"/>
              </svg>
            </a>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <footer style={{ marginTop: 0, padding: '48px 20px', background: '#f4f6f8', color: '#111' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', gap: 32, alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        {columnOrder.map(colKey => renderColumn(colKey))}
      </div>

      <div style={{ maxWidth: 1280, margin: '28px auto 0 auto', color: '#666', fontSize: 13, textAlign: 'center' }}>
        {settings?.copyrightText || `© ${new Date().getFullYear()} Globe. Të gjitha të drejtat të rezervuara.`}
      </div>
    </footer>
  );
}
